import request from '@/utils/request'
// ------------------ 标准库的接口
/**
 * 搜索下拉框选项集合的获取
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=467
 * @param servicetype init 渠道类别
 * return
 * select1 {Array} select2 {Array} 目前使用vuex死数据代替select2
 */
export function statndSearchOptions(params) {
  return request({
    url: '/standard/search_options',
    method: 'post',
    data: params
  })
}
/**
 * 标准库列表展示
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=471
 * @param serviceType 是 机构类型 6中
 * @param currentpage 否
 * @param rp 否
 * @param sortname 否 排序字段
 * @param sortorder 排序方式 传asc或desc
 * @param filter 否 数组格式
 */
export function standGetList(params) {
  return request({
    url: '/standard/get_user_list',
    method: 'post', // 可不可以换成post
    data: params
  })
}

/**
 * 标准库删除和批量删除
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=473
 * @param ids 是 逗号分隔的id集合
 */
export function standUserDelete(params) {
  return request({
    url: '/standard/user_del',
    method: 'post',
    data: params
  })
}

/**
 * 标准库还原和批量还原
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=472
 * @param ids 是 逗号链接的id 字符串
 */
export function standRecycleBack(params) {
  return request({
    url: '/standard/recycle_back',
    method: 'post',
    data: params
  })
}
